<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <!-- <span class="masge">当前共有{{ this.total }}条{{this.route.menuName}}</span> -->
      </div>

      <div class="left">
        <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick
          @click="handleAdd">发起调价</el-button>
        <span style="color: red; background-color: #f1dfbf"><i
            class="el-icon-warning"></i>&nbsp;提示:1、可以直接发起调价，也可以从下方两个分页中勾选需要调价的数据发起调价；2、建议同一商品代码的产品批量调价或单个产品调价。</span>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="库存表价格差异" name="first">
          <div class="header">
            <div class="left">
              <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                @click="toggleSelection()">取消勾选</el-button>
              <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                @click="priceUpdateStockExport" v-loading="exportButtonLoading"
                :disabled="exportButtonLoading">导出</el-button>
              <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
                @reset="reset"></SelectFilter>
            </div>
            <div class="right">
              <span v-if="this.activeName == 'first'" style="line-height: 30px; font-size: 16px">数量合计：<span
                  class="font">{{ this.selectionTotalNumber }}
                </span></span>
              <span v-if="this.activeName == 'first'" style="line-height: 30px; font-size: 16px">采购价金额合计：<span
                  class="font">{{ this.selectionTotalAmount }}
                </span></span>
                <el-button class="btn primary" type="primary" style="margin-right: 10px"
                @click="showTransfer">自定义设置</el-button>
              <div class="search">
                <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                  <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                </el-input>
                <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
              </div>
              <span v-preventReClick @click="reset">重置</span>
            </div>
          </div>

          <div v-if="tableHaeder.length>0">
            <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
            @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
              <template slot="before">
                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                </el-table-column>
              </template>
              <template slot="after">
      
              </template>
            </CustomTable>
          </div>
         <div v-else>
          <el-table ref="multipleTable" border v-loading="loading" row-key="id" :data="tableData"
          :max-height="tableHeight" style="min-height: 500px; width: 100%" @selection-change="handleSelectionChange" stripe
          :header-cell-style="{ background: '#DDEBFF' }">
          <template slot="empty">
            <div class="empty-div" :style="{ height: tableHeight + 'px' }">
              <img src="../../../../assets/noData.png" width="240" height="240" />
              <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
              <div class="empty-rest" @click="reset">恢复默认</div>
            </div>
          </template>
          <el-table-column fixed :reserve-selection="true" type="selection" width="55"
            align="center"></el-table-column>
          <el-table-column prop="productCode" width="120" label="商品代码"></el-table-column>
          <el-table-column prop="supplierProductNo" width="170" label="供应商产品编码"
            show-overflow-tooltip></el-table-column>
          <el-table-column prop="stockCategoryName" width="120" label="库存类型"></el-table-column>
          <el-table-column prop="billingLogoName" width="80" label="是否计费"></el-table-column>
          <el-table-column prop="distributionName" width="80" label="是否集采"></el-table-column>
          <el-table-column prop="productName" width="150" label="产品名称" show-overflow-tooltip></el-table-column>
          <el-table-column prop="specName" width="100" label="规格/型号" show-overflow-tooltip></el-table-column>
          <el-table-column prop="manufacturerName" width="150" label="生产厂家" show-overflow-tooltip></el-table-column>
          <el-table-column prop="price" width="100" label="在库采购价"></el-table-column>
          <el-table-column prop="billingPrice" width="100" label="在库计费价"></el-table-column>
          <el-table-column prop="onlinePrice" width="100" label="在库挂网价"></el-table-column>
          <el-table-column prop="priceMonitorPrice" width="100" label="平台采购价"></el-table-column>
          <el-table-column prop="priceMonitorBidPrice" width="100" label="平台最高价"></el-table-column>
          <el-table-column prop="batch" width="100" label="批号">
            <template slot-scope="scope">
              {{ scope.row.batch?scope.row.batch:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="minUnit" width="80" label="单位"></el-table-column>
          <el-table-column prop="stockQuantity" width="80" label="库存数量"></el-table-column>
          <el-table-column prop="validityDate" width="120" label="有效期">
            <template slot-scope="scope">{{
              scope.row.validityDate?
              parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
              :'-'
              }}</template>
          </el-table-column>
          <el-table-column prop="supplierName" width="150" label="供应商" show-overflow-tooltip></el-table-column>
          <el-table-column prop="warehouseName" width="100" label="库房" show-overflow-tooltip></el-table-column>
          <el-table-column prop="newProductId" width="100" label="产品id" >
            <template slot-scope="scope">
              {{ scope.row.newProductId?scope.row.newProductId:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="mainNo" width="100" label="主条码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.mainNo?scope.row.mainNo:'-' }}
            </template>
          </el-table-column>
          <el-table-column prop="traceNo" width="100" label="溯源码" show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.traceNo?scope.row.traceNo:'-' }}
            </template>
          </el-table-column>
        </el-table>
        </div>
      
          <!-- <div class="masge" style="float: left;line-height: 2.1;margin-left: 1215px">
            <span>共{{ this.total }}条</span>
          </div> -->
          <div class="pagination" style="margin-top: 20px">
            <el-pagination background style="float: right" layout="sizes, prev, pager, next, jumper"
              :page-sizes="[500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
              :current-page="query.pageIndex" :total="this.total" @current-change="changePage">
            </el-pagination>
            <div class="masge" style="float: right; line-height: 2.1">
              <span>共{{ this.total }}条</span>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="产品目录价格差异" name="second">
          <div class="header">
            <div class="left">
              <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                @click="productToggleSelection()">取消勾选</el-button>
              <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary"
                @click="priceUpdateProductExport" v-loading="exportButtonLoading"
                :disabled="exportButtonLoading">导出</el-button>
              <SelectFilter ref="selectFilter" :options="filterOptionsProduct" :query="productQuery"
                @filterChange="productQueryChange" @reset="productReset"></SelectFilter>
            </div>
            <div class="right">
              <div class="search">
                <!-- <input type="text" v-model="query.keyWord" @blur="queryChange" /> -->
                <el-input type="text" v-model="productQuery.keyWord" @input="inputEvt"
                  @keyup.enter.native="productQueryChange">
                  <i slot="suffix" class="el-icon-search" @click="productQueryChange"></i>
                </el-input>
                <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
              </div>
              <span v-preventReClick @click="productReset">重置</span>
            </div>
          </div>

          <el-table ref="productMultipleTable" v-loading="loading" border row-key="id" :data="productTableData"
            :max-height="tableHeight" style="min-height: 500px; width: 100%"
            @selection-change="handleProductSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
            <template slot="empty">
              <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                <img src="../../../../assets/noData.png" width="240" height="240" />
                <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                <div class="empty-rest" @click="reset">恢复默认</div>
              </div>
            </template>
            <el-table-column fixed :reserve-selection="true" type="selection" width="55"
              align="center"></el-table-column>
            <el-table-column prop="productCode" width="120" label="商品代码"></el-table-column>
            <el-table-column prop="no" width="180" label="供应商产品编码">
              
            </el-table-column>
            <el-table-column prop="billingLogoName" width="80" label="是否计费"></el-table-column>
            <el-table-column prop="distributionName" width="80" label="是否集采"></el-table-column>
            <el-table-column prop="productName" min-width="160" label="产品名称"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="specName" width="120" label="规格型号" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="manufacturerName" width="140" label="生产厂家"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="supplierName" width="140" label="供应商"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="purchasePrice" width="80" label="院采购价"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="billingPrice" width="80" label="院计费价"
              :show-overflow-tooltip="true"></el-table-column>
            <el-table-column prop="priceMonitorPrice" width="100" label="平台采购价"></el-table-column>
            <el-table-column prop="priceMonitorBidPrice" width="100" label="平台最高价"></el-table-column>
            <el-table-column prop="isEnableName" width="100" label="是否启用">
              <template slot-scope="scope">
                {{ scope.row.isEnabled == 1 ? "是" : "否" }}
              </template>
            </el-table-column>
            <el-table-column prop="newProductId" width="100" label="产品id" />
          </el-table>

          <div class="pagination" style="margin-top: 20px">
            <el-pagination background style="float: right" layout="sizes, prev, pager, next, jumper"
              :page-sizes="[500, 1000]" :page-size="productQuery.pageSize" @size-change="productHandleSizeChange"
              :current-page="productQuery.pageIndex" :total="productTotal" @current-change="productChangePage">
            </el-pagination>
            <!-- margin-left: 1215px -->
            <div class="masge" style="float: right; line-height: 2.1">
              <span>共{{ this.productTotal }}条</span>
            </div>
          </div>
          <!-- class="masge" -->
          <!-- <span>共{{ this.productTotal }}条</span> -->
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <PriceUpdateDialog ref="selectDialog" :show="showSelectDialog" :dialogTitle="selectDialogTitle" @close="closeSelectDialog" :filterOptions="filterOptions"></PriceUpdateDialog> -->

    <el-dialog title="价格调整" :visible.sync="open" :max-height="100" style="min-height: 100px; width: 100%" :center="true"
      width="900px" :before-close="cancelChildDialog" :close-on-click-modal="false">
      <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
        <el-row>
          <el-col :span="6">
            <el-form-item label="请选择调价类型" prop="adjustPriceType">
              <el-select v-model="form.adjustPriceType" :disabled="!editMode" placeholder="请选择"
                @change="adjustPriceTypeChange">
                <el-option v-for="item in AdjustPriceType" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="商品代码" v-if="form.adjustPriceType === 0" prop="productCode">
              <el-input :disabled="!editMode" v-model="form.productCode" @change="noChange"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>

          </el-row> -->
        <el-row>
          <el-col :span="24">
            <el-form-item label="供应商产品编码" v-if="form.adjustPriceType === 1" prop="supplierProductIds">
              <el-select v-model="selevtValue" :disabled="!editMode" reserve-keyword collapse-tags clearable multiple
                filterable placeholder="请选择" :filter-method="getProductList" style="width: 100%"
                @change="productChange">
                <el-option v-for="(item, index) in STATIC_SupplierProducts" :key="index" :label="item.no +
                  ' ' +
                  item.productName +
                  ' ' +
                  item.specName +
                  ' ' +
                  item.manufacturerName
                  " :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="6">
            <el-form-item label="原采购价">
              <el-input disabled type="number" v-model="form.oldPurchasePrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="原计费价">
              <el-input disabled type="number" v-model="form.oldBillingPrice"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="原挂网价">
              <el-input disabled type="number" v-model="form.oldOnlinePrice"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="purchasePrice" label="新采购价">
              <el-input :disabled="!editMode" type="number" v-model="form.purchasePrice" placeholder="请输入采购价"
                @change="purchasePriceChange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="billingPrice" label="新计费价">
              <el-input disabled type="number" v-model="form.billingPrice" placeholder="请输入计费价"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="onlinePrice" label="新挂网价">
              <el-input :disabled="!editMode" type="number" v-model="form.onlinePrice" placeholder="请输入挂网价"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="isUpdateProduct" label="是否更新目录价格">
              <el-select v-model="form.isUpdateProduct" :disabled="!editMode" placeholder="请选择">
                <el-option v-for="item in isUpdateProductOptions" :key="item.id" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item prop="isUpdateStock" label="是否更新库存表">
              <el-select v-model="form.isUpdateStock" :disabled="!editMode" placeholder="请选择">
                <el-option v-for="item in UpdateStockType" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6"> -->
          <i class="el-icon-warning" style="color: orange" />
          <span style="color: red; line-height: 82px; font-size: 16px">请谨慎选择
          </span>
          <!-- </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注">
              <el-input :disabled="!editMode" v-model="form.remark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="创建人" v-if="form.id != 0">
              <el-input disabled v-model="form.createdUserName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建时间" v-if="form.id != 0">
              <el-input disabled v-model="form.createdTime"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item>
              <span style="color: red">建议上传调价证明等相关材料附件 </span>
              <UploadFileList :fileList="form.fileInfos" btnShowType="always" :disabled="!editMode"
                @fileChange="fileChange" :showLabel="false"></UploadFileList>
            </el-form-item>
          </el-col>
        </el-row>
        <ApproveInfo ref="approveInfo" v-if="showWorkFlowInfo" @change="approveInfoChange"></ApproveInfo>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="editMode" v-loading="loading" class="btn primary" v-preventReClick
          @click="continueAdd">新增下一条</el-button>
        <el-button v-if="editMode" class="btn default" v-preventReClick @click="cancel">取 消</el-button>
        <my-button v-if="editMode" v-loading="loading" class="btn primary" type="primary" v-preventReClick
          @click="submit">确
          定</my-button>
        <my-button v-if="showWorkFlowInfo" class="btn primary" type="primary" v-preventReClick @click="approve">确
          定</my-button>
        <el-button v-if="!editMode" class="btn default" v-preventReClick @click="open = false">返 回</el-button>
      </div>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

 <script>
import {
  GetStockProductDifferences,
  GetSupplierProductPriceDifferences,
  ExportStockPriceDifference,
  ExportSupplierProductPriceDifference,
  GetSupplierProducts,
  SaveProductPriceUpdate,
  CheckProductEnableState,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import {
  StockCategoryOptions,
  WhetherOptions,
  AdjustPriceType,
  UpdateStockType,
  isUpdateProductOptions,
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import UploadFileList from "@/components/upload-file-list";
// import Edit from '.././price-update/index'

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
    UploadFileList,
    // Edit
  },
  data() {
    return {
      // GetDatasAction: GetStocks,
      exportAction: ExportStockPriceDifference,
      exportAction: ExportSupplierProductPriceDifference,
      StockCategoryOptions: StockCategoryOptions,
      WhetherOptions: WhetherOptions,
      isUpdateProductOptions:isUpdateProductOptions,
      AdjustPriceType: AdjustPriceType,
      UpdateStockType: UpdateStockType,
      filterOptions: [
        {
          name: "商品代码",
          type: "input",
          code: "productCode",
        },
        {
          name: "库存类型",
          type: "select",
          code: "category",
          data: StockCategoryOptions,
          // defaultValue: this.$route.params ? '' : 0
        },
        {
          name: "是否计费",
          type: "select",
          code: "isBilling",
          data: WhetherOptions,
          // defaultValue: 1
        },
        {
          name: "是否集采",
          type: "select",
          code: "isDistribution",
          data: WhetherOptions,
          // defaultValue: 1
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "在库采购价",
          type: "numberRange",
          startCode: "minPurchasePrice",
          endCode: "maxPurchasePrice",
        },
      ],
      filterOptionsProduct: [
        {
          name: "商品代码",
          type: "input",
          code: "productCode",
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "no",
        },
        {
          name: "是否计费",
          type: "select",
          code: "billingLogo",
          data: WhetherOptions,
          // defaultValue: 1
        },
        {
          name: "是否集采",
          type: "select",
          code: "isDistribution",
          data: WhetherOptions,
          // defaultValue: 1
        },
        {
          name: "是否启用",
          type: "select",
          code: "isEnabled",
          data: WhetherOptions,
          defaultValue: 1,
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "院采购价",
          type: "numberRange",
          startCode: "minPurchasePrice",
          endCode: "maxPurchasePrice",
        },
      ],
      activeName: "first",
      query: {
        pageIndex: 1,
        pageSize: 500,
      },
      productQuery: {
        pageIndex: 1,
        pageSize: 500,
      },
      productTotal: 0,
      total: 0,
      tableData: [],
      productTableData: [],
      productAllTableData: [],
      allTableData: [],
      loading: false,
      childMultipleSelection: [], // 库存选择数据
      multipleSelection: [], // 产品选中数据
      selectionTotalNumber: 0, //勾选数量
      selectionTotalAmount: 0, //勾选金额
      showSelectDialog: false,
      selectDialogTitle: "价格调整",
      isContinue: false,
      waitIng: false,
      form: {},
      editMode: false,
      open: false,
      rules: {
        purchasePrice: [
          { required: true, message: "请输入采购价", trigger: "blur" },
        ],
        billingPrice: [
          { required: true, message: "请输入计费价", trigger: "blur" },
        ],
        onlinePrice: [
          { required: true, message: "请输入挂网价", trigger: "blur" },
        ],
        adjustPriceType: [
          { required: true, message: "请选择调价类型", trigger: "blur" },
        ],
        productCode: [
          { required: true, message: "请输入商品代码", trigger: "blur" },
        ],
        supplierProductIds: [
          { required: true, message: "请选择供应商产品编码", trigger: "blur" },
        ],
        isUpdateStock: [
          {
            required: true,
            message: "请选择是否更新库存价格",
            trigger: "blur",
          },
        ],
        isUpdateProduct: [
          {
            required: true,
            message: "请选择是否更新目录价格",
            trigger: "blur",
          },
        ],
        // onlineNo: [
        //   { required: true, message: '请输入挂网号或供货商产品编码', trigger: 'blur' }
        // ]
      },
      resultData: [], // 传入的值
      priceSource: 0, // 传入的来源  0 直接调价，1 库存，2产品
      selevtValue: [],
      exportButtonLoading: false,
      firstSupplierProductBillLogo: 0,
      // 遮罩层
    };
  },

  methods: {
    getData() {
      this.loading = true;
      GetStockProductDifferences(this.query)
        .then((res) => {
          this.allTableData = res.returnData.data;

          this.total = this.allTableData ? this.allTableData.length : 0;
          this.tableData = this.getPaginationData(
            this.allTableData,
            this.query.pageIndex,
            this.query.pageSize
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProductData() {
      this.loading = true;
      GetSupplierProductPriceDifferences(this.productQuery)
        .then((res) => {
          this.productAllTableData = res.returnData.data;

          this.productTotal = this.productAllTableData
            ? this.productAllTableData.length
            : 0;
          this.productTableData = this.getPaginationData(
            this.productAllTableData,
            this.productQuery.pageIndex,
            this.productQuery.pageSize
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelChildDialog() {
      this.open = false;
    },
    fileChange(e) {
      this.form.fileInfos = e;
    },
    getProductList(keyWord) {
      // ,isEnabled:1
      this.getSupplierProducts({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
      });

      // this.getSupplierProducts({ keyWord: keyWord, pageIndex: 1, pageSize: 100,isEnabled:1 })
    },
    adjustPriceTypeChange(val) {

      if (
        Object.keys(this.resultData) != null &&
        Object.keys(this.resultData).length > 0
      ) {
        this.form.supplierProductIds = this.resultData
          .map((t) => t.id)
          .join(";");
        if (val == 0) {
          this.form.productCode = this.resultData[0].productCode;
        }
        this.form.oldPurchasePrice = this.resultData[0].purchasePrice;
        this.form.oldOnlinePrice = this.resultData[0].OnlinePrice;
        this.form.oldBillingPrice = this.resultData[0].billingPrice;
        if (
          this.form.supplierProductIds != ";" &&
          this.form.supplierProductIds != ""
        ) {
          this.resultData.map((item) => {
            let isExistArr = this.STATIC_SupplierProducts.filter(
              (e) => e.id == item.id
            );
            if (!isExistArr == null || isExistArr.length == 0) {
              this.STATIC_SupplierProducts.push(item);
            }
          });
          this.selevtValue = this.resultData.map((e) => e.id);
        }
      }
    },

    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.isUpdateProduct == 0 && this.form.isUpdateStock == 0) {
          this.$my_message(
            `「是否更新目录价格」和「是否更新库存价格」不能都是"否"`,
            "error"
          );
          return false;
        }
        if (this.waitIng) {
          this.$my_message(
            `价格更新数据较大，本页面操作请等待上一次执行完成`,
            "warning"
          );
          return false;
        }
     
          SaveProductPriceUpdate(this.form)
            .then((res) => {
              this.open = false;
              this.$my_message(`执行成功`, "success");
              this.getData();
              this.getProductData();
              this.$refs.multipleTable.clearSelection();
              this.$refs.productMultipleTable.clearSelection();
            })
            .then(() => {
              if (this.isContinue) {
                let adjustPriceType = this.form.adjustPriceType;
                this.handleAdd();
                this.isContinue = false;
                this.form.adjustPriceType = adjustPriceType;
              }
            })
            .finally(() => {
              this.$store.dispatch("SetLoading", false);
            });
     
      });
    },
    // 取消编辑
    cancel() {
      this.$store.dispatch("SetLoading", false);
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.open = false;
      }
    },
    productChange(val) {
      this.form.supplierProductIds = val

      var sps = this.form.supplierProductIds
      var sp = this.STATIC_SupplierProducts.filter((e) => e.id == sps[0]);
      if (sp && sp.length > 0) {
        this.noChange(sp[0].no);
      }
    },
    noChange(val) {
      if (!val) {
        return;
      }

      GetSupplierProducts({
        pageIndex: 1,
        pageSize: 1,
        onlineNoOrNo: val,
      }).then((res) => {
        var result = res.returnData.data;
        if (result) {
          console.log(result, "result");
          this.$set(this.form, "oldOnlinePrice", result[0].onlinePrice);
          this.$set(this.form, "oldPurchasePrice", result[0].purchasePrice);
          this.$set(this.form, "oldBillingPrice", result[0].billingPrice);
          this.firstSupplierProductBillLogo = result[0].billingLogo;
        }
      });
    },
    inputEvt() {
      this.$forceUpdate();
    },
    purchasePriceChange(val) {
      if (this.firstSupplierProductBillLogo == 1) {
        this.form.billingPrice = val;
      } else {
        this.form.billingPrice = 0;
      }
      this.form.onlinePrice = val;
    },
    resetForm() {
      this.form = {
        id: 0,
        no: "",
        createdUserName: this.userInfo.name,
        createdTime: this.parseTime(new Date()),
        productCode: "",
        supplierProductIds: "",
        oldPurchasePrice: 0,
        oldOnlinePrice: 0,
        oldBillingPrice: 0,
        priceSource: 0,
        isUpdateProduct: 2,
        isUpdateStock: 1,
        billingPrice: "",
        onlinePrice: "",
        purchasePrice: "",
        adjustPriceType: "",
        orgCode :sessionStorage.getItem('orgId')
      };
      this.selevtValue = [];
      this.firstSupplierProductBillLogo = 0;
      // this.childMultipleSelection = []
      // this.multipleSelection = []
    },
    priceUpdateProductExport() {
      this.exportButtonLoading = true;
      ExportSupplierProductPriceDifference(this.productQuery)
        .then((res) => new Blob([res]))
        .then((data) => {
          const blobUrl = window.URL.createObjectURL(data);
          const a = document.createElement("a");
          a.style.display = "none";
          a.download = new Date().getTime().toString() + ".xlsx";
          a.href = blobUrl;
          a.click();
        })
        .finally((res) => {
          this.exportButtonLoading = false;
        });
    },
    priceUpdateStockExport() {
      this.exportButtonLoading = true;
      ExportStockPriceDifference(this.query)
        .then((res) => new Blob([res]))
        .then((data) => {
          const blobUrl = window.URL.createObjectURL(data);
          const a = document.createElement("a");
          a.style.display = "none";
          a.download = new Date().getTime().toString() + ".xlsx";
          a.href = blobUrl;
          a.click();
        })
        .finally((res) => {
          this.exportButtonLoading = false;
        });
    },
    handleAdd() {
      // this.routePushWithParams("/price-update-index", this.query, { open: true });
      // this.$router.push("/price-update");

      let source = 0;
      let prictData = [];
      if (
        this.childMultipleSelection != null &&
        this.childMultipleSelection.length > 0
      ) {
        source = 1;
        prictData = this.childMultipleSelection;
      }
      if (this.multipleSelection != null && this.multipleSelection.length > 0) {
        source = 2;
        prictData = this.multipleSelection;
      }
      // 发起调价按钮来源 0 直接调价，1 库存，2产品
      //  this.$router.push({ path: '/price-update', query: { priceSource: source, selection: prictData } })
      // this.$router.push({ name: 'ProductPriceUpdate', params: { priceSource: source, selection: prictData } })

      this.form.priceSource = source;
      if (source == 1) {
        prictData.map((e) => {
          // 去重且重新赋值
          var arr = this.resultData.filter(
            (item) => item.id == e.supplierProductId
          );
          if (arr == null || arr.length == 0) {
            e.id = e.supplierProductId;
            e.no = e.supplierProductNo;
            this.resultData.push(e);
          }
        });
      } else {
        this.resultData = prictData;
      }

      // 校验条件
      let productCodeList = [];
      let stockList = [];
      let productList = [];
      for (let i = 0; i < this.resultData.length; i++) {
        var a = this.resultData.filter(
          (r1) => r1.productCode != this.resultData[i].productCode
        );
        if (a.length > 0) {
          productCodeList.push(a[0]);
        }
        var b = this.resultData.filter(
          (r1) => r1.price != this.resultData[i].price
        );
        if (b.length > 0) {
          stockList.push(b[0]);
        }
        var c = this.resultData.filter(
          (r1) => r1.purchasePrice != this.resultData[i].price
        );
        if (c.length > 0) {
          productList.push(c[0]);
        }
      }
      // console.log(productCodeList, stockList, productList, " -productCodeList")

      if (productCodeList.length > 0) {
        this.$confirm("提示", {
          title: "提示",
          type: "warning",
          message: "选择中有不同商品代码的产品",
        })
          .then(() => {
            if (stockList.length > 0 || productList.length > 0) {
              return this.$confirm("提示", {
                title: "提示",
                type: "warning",
                message: "所选数据采购价,不都相等，是否继续批量调价",
              });
            }
          })
          .then(() => {
            this.open = true;
          });
      } else if (stockList.length > 0 || productList.length > 0) {
        this.$confirm("提示", {
          title: "提示",
          type: "warning",
          message: "所选数据采购价,不都相等，是否继续批量调价",
        }).then(() => {
          this.open = true;
        });
      } else {
        this.open = true;
      }

      this.resetForm();
      this.editMode = true;
    },
    closeSelectDialog() {
      this.open = false;
    },
    /**
     * 继续添加
     */
    continueAdd() {
      this.isContinue = true;
      this.submit();
    },
    handleClick(tab, event) {
      console.log(event, "event");
      if (tab.name == "second") {
        this.getProductData();
      } else {
        this.getData();
      }
    },
    toggleSelection() {
      this.$refs.multipleTable.clearSelection();
    },
    productToggleSelection() {
      this.$refs.productMultipleTable.clearSelection();
    },
    // 改变当前页
    changePage(val) {
      this.$set(this.query, "pageIndex", val);
      this.tableData = this.getPaginationData(
        this.allTableData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      this.tableData = this.getPaginationData(
        this.allTableData,
        this.query.pageIndex,
        this.query.pageSize
      );
    },
    productChangePage(val) {
      this.$set(this.productQuery, "pageIndex", val);
      this.productTableData = this.getPaginationData(
        this.productAllTableData,
        this.productQuery.pageIndex,
        this.productQuery.pageSize
      );
    },
    productHandleSizeChange(val) {
      this.$set(this.productQuery, "pageSize", val);
      this.productTableData = this.getPaginationData(
        this.productAllTableData,
        this.productQuery.pageIndex,
        this.productQuery.pageSize
      );
    },
    productQueryChange() {
      this.$set(this.productQuery, "pageIndex", 1);
      this.getProductData();
    },
    productReset() {
      this.productQuery = {
        pageIndex: 1,
        pageSize: 500,
      };
      // this.$set(this.productQuery, "pageIndex", 1);
      this.getProductData();
    },
    getPaginationData(list, pageIndex, pageSize) {
      return list.slice((pageIndex - 1) * pageSize, pageIndex * pageSize);
    },
    handleProductSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    handleSelectionChange(selection) {
      this.childMultipleSelection = selection;
      // this.selectionTotalNumber = this.childMultipleSelection.length;
      let amount = 0;
      let number = 0;
      this.childMultipleSelection.filter((item) => {
        amount += item.price;
        number += item.stockQuantity;
      });
      this.selectionTotalNumber = number.toFixed(3) * 1;
      this.selectionTotalAmount = amount.toFixed(3) * 1;
    },
  },
  mounted() {
    this.$set(this.$refs["selectFilter"].query, "category", 0);
    this.$set(this.$refs["selectFilter"].query, "categoryName", "普通");
    // this.$refs["selectFilter"].query.category = 0
    // this.$refs["selectFilter"].query.categoryName = '普通'
    if (this.$route.params && this.$route.params.startDate) {
      this.$refs["selectFilter"].query.category = "";
      this.$set(this.$refs["selectFilter"].query, "categoryName", "");
      // this.$set(this.$route.params, "category", 0);
      // console.log("this.query", this.query);
    }
  },
  created() {
    // this.query.category = 0
    this.$set(this.query, "category", 0);
    if (this.$route.params && this.$route.params.startDate) {
      this.query.startDate = this.parseTime(this.$route.params.startDate);
      this.query.endDate = this.parseTime(this.$route.params.endDate);
      this.query.category = "";
    }
    this.getProductList("");
  },
};
</script>

<style lang="scss" scoped>
.font {
  color: black;
  margin: 0px 5px 10px;
}

// .dialog-tab-footer {
//   text-align: right;
//   margin: 10px 0;
//   // margin-left: 20px;
// }</style>
